import type { SelectProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { AssistantInfo } from "../../../../../../services/api/instances/assistantsApi/types";
import { useAppDispatch } from "../../../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppSelectOption } from "../../../../../../shared/components/AppSelect/AppSelectOption";
import { SelectBlock } from "../../../../../../shared/components/SelectBlock";
import { SettingsSwitch } from "../../../../../../shared/components/SelectBlock/SettingsSwitch";
import { selectStylistMode } from "../../../../redux/selectors";
import { setStylistMode } from "../../../../redux/slice";
import styles from "./styles.module.css";

type Props = SelectProps & {
  label: string;
  itemText: string;
  assistants: AssistantInfo[];
};

export const AssistantSelection: FC<Props> = ({
  label,
  itemText,
  assistants,
  ...props
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const stylistMode = useAppSelector(selectStylistMode);

  const handleSwitch = () => {
    return stylistMode === "вручную"
      ? dispatch(setStylistMode("auto"))
      : dispatch(setStylistMode("вручную"));
  };

  return (
    <SelectBlock
      hasSettings={true}
      options={assistants.map((assistant) => (
        <AppSelectOption key={assistant.id} value={assistant.name}>
          {assistant.name}
        </AppSelectOption>
      ))}
      itemText={itemText}
      label={label}
      {...props}
    >
      <SettingsSwitch
        pickedValue={stylistMode}
        switches={[
          { id: 1, switchName: "AUTO", switchValue: "auto" },
          {
            id: 2,
            switchName: `${t("stylist.manually")}`,
            switchValue: "вручную",
          },
        ]}
        onClick={handleSwitch}
        className={styles.switch}
      />
    </SelectBlock>
  );
};
